import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { X } from 'lucide-react';
const failedSolutions = [{
  solution: 'Libros de autoayuda genéricos',
  why: "Te dicen que 'pienses positivo' — ignoran el dolor real"
}, {
  solution: 'Solo terapia',
  why: 'Ayuda con los síntomas, ignora la herida espiritual'
}, {
  solution: 'Sermones en la iglesia',
  why: 'Hablan al grupo, no al individuo en crisis'
}, {
  solution: 'Contenido motivacional',
  why: 'Se siente bien 10 minutos, luego desaparece'
}, {
  solution: 'El tiempo',
  why: "'Ya va a pasar' — pero no pasa. El patrón se repite."
}];
export function IdentityWound() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[var(--cream)] py-24 md:py-32" data-id="element-214">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-5xl mx-auto px-6" data-id="element-215">
        <div className="space-y-12" data-id="element-216">
          <h2 className="font-display text-4xl md:text-5xl text-[var(--dusk-purple)] text-center" data-id="element-217">
            La Verdad Que Nadie Te Dice
          </h2>

          <p className="text-xl md:text-2xl text-[var(--charcoal)] leading-relaxed text-center max-w-3xl mx-auto" data-id="element-218">
            El problema no eres tú. Es el método.
          </p>

          {/* Failed solutions grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-219">
            {failedSolutions.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white p-6 rounded-lg border-2 border-[var(--charcoal)]/10" data-id="element-220">
                <div className="flex items-start gap-3" data-id="element-221">
                  <X className="w-5 h-5 text-[var(--sunset-coral)] flex-shrink-0 mt-1" data-id="element-222" />
                  <div className="space-y-2" data-id="element-223">
                    <h3 className="font-semibold text-[var(--charcoal)]" data-id="element-224">
                      {item.solution}
                    </h3>
                    <p className="text-sm text-[var(--charcoal)]/70" data-id="element-225">
                      {item.why}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>

          {/* The real wound */}
          <div className="pt-12 border-t-2 border-[var(--warm-gold)]" data-id="element-226">
            <blockquote className="font-display text-3xl md:text-4xl italic text-[var(--dusk-purple)] text-center leading-relaxed max-w-4xl mx-auto" data-id="element-227">
              "Mientras tanto, la herida más profunda sigue intacta. La herida
              de identidad."
            </blockquote>

            <p className="text-xl text-[var(--charcoal)] text-center mt-8 max-w-3xl mx-auto leading-relaxed" data-id="element-228">
              La creencia — instalada años atrás por palabras, rechazos,
              fracasos, traiciones — de que no eres suficiente. De que eres un
              fracaso. De que no mereces paz. De que Dios quizás sí existe...
              pero para otros, no para ti.
            </p>

            <p className="text-2xl font-semibold text-[var(--sunset-coral)] text-center mt-6" data-id="element-229">
              Mientras esa creencia siga ahí, nada cambia de verdad.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}